<template>
  <section class="terms" id="start">
    <div class="container">

      <!-- Header -->
      <div class="terms-header anim-item">
        <div class="badge">
          <i class="bi bi-file-earmark-text-fill"></i>
          Términos & Condiciones
        </div>
        <h1 class="terms-title">Términos y Condiciones<br />de Uso</h1>
        <p class="terms-meta">
          <i class="bi bi-building"></i> GST – Gestión Servicio Técnico
          <span class="dot">·</span>
          <i class="bi bi-calendar3"></i> Vigentes desde 2019
        </p>
        <p class="terms-intro">
          Bienvenido a <strong>GST – Gestión Servicio Técnico</strong>. Al acceder a esta plataforma
          y utilizar nuestros servicios, aceptas cumplir con estos términos y condiciones. Si no estás
          de acuerdo con alguna parte, por favor no utilices nuestra plataforma ni nuestros servicios.
        </p>
      </div>

      <!-- Sections -->
      <div class="sections">

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-globe2"></i></div>
          <div class="section-body">
            <h2 class="section-title">General</h2>
            <p>
              Estos términos y condiciones se aplican a todos los visitantes, usuarios y clientes de
              <strong>GST – Gestión Servicio Técnico</strong>, plataforma tecnológica desarrollada y
              operada por <strong>OPERACION SISTEMICA SAS</strong>. Incluyen, pero no se limitan a,
              el uso de la plataforma para la administración y gestión de servicios técnicos,
              incluyendo el registro de clientes, productos, repuestos, ventas, órdenes de servicio
              y reportes técnicos.
            </p>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-patch-check-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">Propiedad Intelectual</h2>
            <p>
              El contenido publicado en esta plataforma —incluyendo texto, gráficos, logos e
              imágenes, así como la compilación de estos— es propiedad de
              <strong>OPERACION SISTEMICA SAS</strong> y está protegido por las leyes de derechos
              de autor y marcas comerciales de Colombia y tratados internacionales.
            </p>
            <p>
              No se permite la reproducción, distribución o uso de cualquier contenido sin el
              permiso expreso y por escrito de OPERACION SISTEMICA SAS.
            </p>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-laptop-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">Uso de la Plataforma</h2>
            <p>
              La plataforma GST debe ser utilizada de manera responsable y acorde con los propósitos
              previstos. No se permite el uso de la plataforma para fines ilegales, fraudulentos o
              dañinos, ni la interferencia con su funcionamiento ni el acceso no autorizado a
              sistemas, datos o contraseñas.
            </p>
            <p>
              OPERACION SISTEMICA SAS se reserva el derecho de modificar estos términos en cualquier
              momento. Es responsabilidad del usuario revisarlos periódicamente. Los servicios están
              sujetos a disponibilidad y pueden ser modificados o retirados sin previo aviso.
            </p>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-tags-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">Precios y Planes</h2>
            <p>
              Todos los precios de los planes y servicios están sujetos a cambio sin previo aviso.
              Nos reservamos el derecho de corregir cualquier error en precios o información de
              servicios en cualquier momento. Los precios aplicables serán los vigentes al momento
              de la contratación o suscripción.
            </p>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-credit-card-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">Facturación y Pagos</h2>
            <p>
              La contratación de los servicios de GST implica la aceptación de las tarifas vigentes.
              Los pagos se procesarán a través de los medios de pago habilitados en la plataforma.
              En caso de mora, GST se reserva el derecho de suspender o cancelar el acceso hasta
              que se regularice la situación.
            </p>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-arrow-counterclockwise"></i></div>
          <div class="section-body">
            <h2 class="section-title">Cancelaciones y Devoluciones</h2>
            <p>
              Las cancelaciones de suscripciones estarán sujetas a los términos del plan contratado.
              No se realizarán devoluciones de pagos ya procesados, salvo error comprobado por parte
              de OPERACION SISTEMICA SAS.
            </p>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">Limitación de Responsabilidad</h2>
            <p>
              OPERACION SISTEMICA SAS no será responsable por daños indirectos, incidentales,
              especiales, consecuentes o punitivos, incluyendo sin limitación pérdida de beneficios,
              datos, uso, buena voluntad u otras pérdidas intangibles, resultantes del uso o la
              incapacidad de usar la plataforma o nuestros servicios.
            </p>
          </div>
        </div>

        <div class="section-card section-card--last">
          <div class="section-icon"><i class="bi bi-shield-fill-check"></i></div>
          <div class="section-body">
            <h2 class="section-title">Políticas de Garantía</h2>
            <p>
              Al ser un servicio de software, GST no ofrece garantía por defectos de fabricación,
              sino por el correcto funcionamiento de la plataforma según sus especificaciones.
              OPERACION SISTEMICA SAS se compromete a corregir los fallos técnicos imputables a la
              plataforma; toda reclamación debe gestionarse a través de los canales oficiales de
              soporte con una descripción detallada de la falla.
            </p>
            <p class="exclusion-label">La garantía <strong>no aplica</strong> en los siguientes casos:</p>
            <ul class="exclusion-list">
              <li><i class="bi bi-x-circle-fill"></i> Instalación indebida o configuración incorrecta por parte del usuario</li>
              <li><i class="bi bi-x-circle-fill"></i> Manipulación no autorizada de la plataforma</li>
              <li><i class="bi bi-x-circle-fill"></i> Mal uso o uso no acorde con los propósitos previstos</li>
              <li><i class="bi bi-x-circle-fill"></i> Fallos de conectividad, ataques cibernéticos o casos de fuerza mayor</li>
            </ul>
            <p>
              La responsabilidad no cubre daños indirectos o consecuenciales derivados del uso
              de la plataforma.
            </p>
          </div>
        </div>

      </div>

      <!-- Footer note -->
      <div class="terms-footer anim-item">
        <i class="bi bi-building"></i>
        <span>OPERACION SISTEMICA SAS · NIT 901227220-8 · © 2019–2026 GST. Todos los derechos reservados.</span>
      </div>

    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue'
import { useRoute } from 'vue-router'

defineProps({ darkMode: Boolean })

const route = useRoute()

import { onMounted, nextTick } from 'vue'
onMounted(() => {
  nextTick(() => {
    if (route.hash) {
      const id = route.hash.replace('#', '')
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ block: 'start' })
      }
    }
  })
})
</script>

<style scoped>
.terms {
  min-height: 100vh;
  background: var(--bg);
  padding: 5rem 0 4rem;
  transition: background 0.35s;
}

.container {
  max-width: 860px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* ══ HEADER ══ */
.terms-header {
  text-align: center;
  margin-bottom: 3rem;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  color: var(--accent);
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.35rem 0.9rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
}

.terms-title {
  font-size: clamp(1.8rem, 4vw, 3rem);
  font-weight: 900;
  letter-spacing: -0.04em;
  line-height: 1.15;
  color: var(--text);
  margin-bottom: 1rem;
  transition: color 0.35s;
}

.terms-meta {
  font-size: 0.88rem;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  transition: color 0.35s;
}

.terms-meta i { color: var(--accent); }
.dot { opacity: 0.4; }

.terms-intro {
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.7;
  max-width: 640px;
  margin: 0 auto;
  background: var(--bg-card);
  border: 1px solid var(--border-soft);
  border-radius: 1rem;
  padding: 1.25rem 1.5rem;
  transition: background 0.35s, border-color 0.35s, color 0.35s;
}

/* ══ SECTIONS ══ */
.sections {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 2.5rem;
}

.section-card {
  display: flex;
  gap: 1.5rem;
  background: var(--bg-card);
  border: 1px solid var(--border-soft);
  border-radius: 1.25rem;
  padding: 1.75rem;
  transition: background 0.35s, border-color 0.35s;
}

.section-card--last {
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent), 0 4px 24px var(--accent-glow);
}

.section-icon {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--accent);
  transition: background 0.35s, border-color 0.35s;
}

.section-body { flex: 1; }

.section-title {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--text);
  margin-bottom: 0.75rem;
  letter-spacing: -0.02em;
  transition: color 0.35s;
}

.section-body p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.7;
  margin-bottom: 0.75rem;
  transition: color 0.35s;
}

.section-body p:last-child { margin-bottom: 0; }

.exclusion-label {
  font-size: 0.88rem !important;
  color: var(--text) !important;
  margin-top: 0.25rem;
}

.exclusion-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.exclusion-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.88rem;
  color: var(--text-muted);
  line-height: 1.5;
  transition: color 0.35s;
}

.exclusion-list li i {
  color: var(--error, #ef4444);
  font-size: 0.9rem;
  flex-shrink: 0;
  margin-top: 0.15rem;
}

/* ══ FOOTER NOTE ══ */
.terms-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.78rem;
  color: var(--text-muted);
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-light);
  transition: color 0.35s, border-color 0.35s;
}

.terms-footer i { color: var(--accent); }

/* ══ RESPONSIVE ══ */
@media (max-width: 640px) {
  .terms { padding: 3rem 0 2rem; }
  .container { padding: 0 1rem; }

  .section-card {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem;
    text-align: center;
  }

  .section-icon { width: 2.5rem; height: 2.5rem; font-size: 1.1rem; align-self: center; }
  .section-body { text-align: center; }
  .exclusion-list { text-align: left; }
  .exclusion-list li { display: block; padding-left: 1.5rem; position: relative; }
  .exclusion-list li i { position: absolute; left: 0; top: 0.2rem; }
  .terms-title { font-size: clamp(1.5rem, 7vw, 1.8rem); }
  .terms-intro { padding: 1rem; font-size: 0.88rem; }
}

/* ══ PANTALLAS GRANDES ══ */
@media (min-width: 1400px) {
  .container { max-width: 1100px; }
}

@media (min-width: 1920px) {
  .container { max-width: 1300px; }
}

@media (min-width: 2560px) {
  .container { max-width: 1600px; }
}
</style>